export function isValidId(id?: number) {
    return id !== undefined && id > 0;
}
